import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=7648546e&scoped=true&"
import script from "./SearchResults.vue?vue&type=script&lang=ts&"
export * from "./SearchResults.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=7648546e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7648546e",
  null
  
)

export default component.exports